jQuery(document).ready(function () {
  jQuery(".collection-slider").owlCarousel({
    loop: true,
    //margin:10,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 3.6,
      },
      400: {
        items: 4.3,
      },
      600: {
        items: 6,
      },
      768: {
        items: 6.5,
      },
    },
  });
  jQuery(document).ready(function () {
    jQuery("#shop-the-style-slider").owlCarousel({
        loop: true,
        margin:10,
        nav: true,
        dots: true,
        center: true,
        responsive: {
          0: {
            items: 2,
            nav:false,
            margin:0,
          },
          400: {
            items: 2,
            nav:false,
            margin:0,
          },
          600: {
            items: 2,
            nav:false,
            margin:0,
          },
          768: {
                items:3,
                nav:false,
                margin:10,
              },
              991: {
                items:4,
                nav: true,
                margin:10,
              },
              1024: {
                items:5,
                nav: true,
                margin:10,
              },
          },
       });
    });
     jQuery(document).ready(function () {
    jQuery("#shop-the-look-slider").owlCarousel({
        loop: true,
        margin:10,
        nav: true,
        dots: true,
        center: true,
          responsive: {
              0: {
                items: 2,
                nav: false,
                margin:0
              },
              400: {
                items: 2,
                nav:false,
                margin:0
              },
              600: {
                items: 2,
                nav:false,
                margin:0
              },
              768: {
                items:3,
                nav:false,
                margin:10
              },
              991: {
                items:3,
                nav: true,
                margin:10
              },
              1200: {
                items:4,
                nav: true,
                margin:10
              },
          },
       });
    });

  jQuery(".collection_text").owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 2,
        center: true,
      },
      600: {
        items: 3,
        center: true,
      },
      1024: {
        items: 5,
      },
      1600: {
        items: 8,
      },
    },
  });

  var mainHeader = jQuery('.header-sticky-wrapper').outerHeight();
  jQuery('.header-sticky-wrapper').css('height', mainHeader);
  jQuery(window).resize(function() {
    var mainHeader = jQuery('.header-sticky-wrapper').outerHeight();
    jQuery('.header-sticky-wrapper').css('height', mainHeader);
  });
 

  jQuery('.variant-input').click(function(){
    var discount = jQuery(this).attr('data-discount');
    if(discount == undefined || discount == 0){
      jQuery('.product-block--price .product__price.afterchange').removeClass('on-sale');
    }else{
      jQuery('.product-block--price .product__price.afterchange').addClass('on-sale');
    }
  });
  
});

jQuery("body").on("click", "#addToCart", function () {
  var currentVariant = jQuery(this).attr("data-productID");

  let formData = {
    items: [
      {
        id: currentVariant,
        quantity: 1,
      },
    ],
  };
  addItemToCart(formData);
});
async function addItemToCart(formData) {
  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await (await fetch("/")).text();
    doc = new DOMParser().parseFromString(data, "text/html");
    cartDrawerContent = doc.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = cartDrawerContent;
    jQuery(".cart-link__bubble").addClass("cart-link__bubble--visible");
    jQuery("#CartDrawer").removeClass("is-empty");
    document.querySelector(".js-drawer-open-cart").click();
  } catch (error) {
    console.error("Error adding item to cart:", error),
      displayCartError(
        "An error occurred while adding the product to the cart."
      );
  }
}
jQuery("body").on("click", ".check-zweite-liebe", function () {
  if (jQuery(this).prop("checked") == true) {
    addNote("Bitte gebrauchten Karton");
  } else {
    addNote("");
  }
});
function addNote(notedata) {
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: {
      note: notedata, // Clear the note by setting it to an empty string
    },
    dataType: "json",
    success: function (cart) {
      console.log("Note updated");
    },
    error: function (xhr, status, error) {
      console.error("Error clearing note: ", error);
      alert("There was an error clearing your note.");
    },
  });
}

jQuery(window).scroll(function () {
  if (jQuery(window).scrollTop() >= 200) {
    jQuery('.top-main-wrapper').addClass('header-sticky');
  }
  else {
    jQuery('.top-main-wrapper').removeClass('header-sticky');
  }
});

/************************/
function updateWishlistCountFromAppmate() {
   // console.log('Checking wishlist count...');

    // Try to get session ID dynamically from localStorage
    const sid = localStorage.getItem('wk_session_id');

    if (!sid) {
      console.warn('Appmate session ID not found in localStorage as wk_session_id.');
      return;
    }

    $.ajax({
      url: "https://api.appmate.io/v2/wishlists/mine",
      method: "GET",
      timeout: 0,
      headers: {
       // "x-appmate-shp": "ladypolitan.myshopify.com",  // Change to your store domain if needed        
         "x-appmate-shp": Shopify.shop,  // Change to your store domain if needed
        "x-appmate-sid": sid,
        "x-appmate-src": "header" // Optional: context, like 'collection', 'product', etc.
      },
      success: function(response) {
       // console.log('Wishlist response:', response);

        const count = response?.wishlist?.numItems || 0;

        const counterEl = document.querySelector('.wishlist-header-link .wkh-counter');
        const buttonEl = document.querySelector('.wishlist-header-link .wkh-button');

        if (counterEl && buttonEl) {
          counterEl.textContent = count;

          if (count > 0) {
            counterEl.style.opacity = '1';
            buttonEl.classList.add('wkh-selected');
          } else {
            counterEl.style.opacity = '0';
            buttonEl.classList.remove('wkh-selected');
          }
        }
      },
      error: function(xhr, status, error) {
        console.error('Failed to fetch wishlist count:', error);
      }
    });
  }

  // Run on initial page load
  $(document).ready(function() {
    updateWishlistCountFromAppmate();

   
    $("body").on("click", ".wk-button.wk-align-center.wk-align-content-center", function() {     
      setTimeout(updateWishlistCountFromAppmate, 1000);
    });

    $(".shippingnew, .inventory-status-wrap").wrapAll("<div class='inventory-and-shipping-wrap'</div>");
  });

window.onload = function() {
    document.querySelectorAll('.product-block').forEach(function(element, index) {
        element.classList.add('product-block-section' + index);
    });
};